var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { ItemValidators } from "../../../item-validators";
import { AbstractCondition } from "../condition";
/**
 * Options:
 *    - degree
 */
var Mobility = /** @class */ (function (_super) {
    __extends(Mobility, _super);
    function Mobility() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Mobility.validate = function (item, odontogram, items) {
        // validate teeth selected
        if (!ItemValidators.hasTeethSelected(item)) {
            return false;
        }
        // validate not missing
        if (!ItemValidators.notMissingTeeth(item, odontogram)) {
            return false;
        }
        // validate degree
        if (!ItemValidators.hasDegreeSelected(item)) {
            return false;
        }
        return true;
    };
    Mobility.apply = function (odontogram, item) {
        return odontogram;
    };
    Mobility.supports = function (condition) {
        return condition === "mobility";
    };
    Mobility.getItemResume = function (item) {
        return [
            {
                name: "degree",
                value: item.options.degree
                    ? ["diagnosis.options.degree." + item.options.degree]
                    : [],
            },
        ];
    };
    Mobility.getTableData = function (item) {
        return [
            "",
            item.options.degree
                ? ["diagnosis.options.degree." + item.options.degree]
                : [],
        ];
    };
    return Mobility;
}(AbstractCondition));
export { Mobility };



// WEBPACK FOOTER //
// /app/src/app/core/store/plan-editor/diagnosis/conditions/perio/mobility.ts.pre-build-optimizer.js